import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 26, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "", as = "span" }) {
  const Tag = motion[as] || motion.span;
  return (
    <span className={`block overflow-hidden ${className}`}>
      <Tag
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </Tag>
    </span>
  );
}
